import { Styles } from '@typings/common';

export const tabsContainer: Styles = {
  width: { md: '40%' },
  ml: { md: 'auto' },
  mr: { md: 'auto' },
};
